"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DialogTitleDesktop_1 = __importDefault(require("./DialogTitleDesktop"));
var DialogTitleMobile_1 = __importDefault(require("./DialogTitleMobile"));
var DialogTitle = function (props) {
    if (!props.showDialogTitle)
        return null;
    return (props.isMobile
        ? react_1.default.createElement(DialogTitleMobile_1.default, __assign({}, props))
        : react_1.default.createElement(DialogTitleDesktop_1.default, __assign({}, props)));
};
exports.default = DialogTitle;
